import createReducer from '../../store/createReducer';

export const loadingReducer = createReducer(false, {

});

export default loadingReducer;